import { useNavigate } from 'react-router-dom';

interface InsufficientCreditsModalProps {
  isOpen: boolean;
  available: number;
  required: number;
  onClose: () => void;
}

export default function InsufficientCreditsModal({
  isOpen,
  available,
  required,
  onClose,
}: InsufficientCreditsModalProps) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-[100] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-sm w-full p-6 shadow-2xl">
        {/* Icon */}
        <div className="flex items-center justify-center mb-4">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-gray-900 text-center mb-2">
          Credite Insuficiente
        </h3>

        {/* Message */}
        <p className="text-gray-600 text-center text-sm mb-2">
          Ai <span className="font-bold text-red-600">{available}</span> credite disponibile,
          dar ai nevoie de <span className="font-bold text-primary-600">{required}</span> credite
          pentru această acțiune.
        </p>
        <p className="text-gray-500 text-center text-xs mb-6">
          Achiziționează mai multe credite pentru a continua.
        </p>

        {/* Buttons */}
        <div className="flex flex-col gap-3">
          <button
            onClick={() => {
              onClose();
              navigate('/extra-credits');
            }}
            className="w-full py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-bold text-base hover:shadow-lg transition-all"
          >
            💳 Cumpără Credite
          </button>
          <button
            onClick={onClose}
            className="w-full py-3 border border-gray-300 text-gray-600 rounded-xl font-medium hover:bg-gray-50 transition-colors"
          >
            Anulează
          </button>
        </div>
      </div>
    </div>
  );
}
